/**
 * Helpers for gating Circadia-internal-only features by the signed-in user's
 * email domain. Used to keep in-development / staff-only features hidden from
 * regular members (e.g. the live vitals view, "read reminder via device").
 */
export const CIRCADIA_EMAIL_DOMAIN = "@circadia.health";

export const isCircadiaUser = (email?: string | null): boolean =>
  !!email && email.trim().toLowerCase().endsWith(CIRCADIA_EMAIL_DOMAIN);
